import styled from 'styled-components';
import {dFlex, flexColumn, alignCenter} from '../../../../../../globalVariables/GlobalFlex';
import {getToken, getPrimitive, getSpacing, getFontWeight, getFontSize} from '@tickchak/react-share/app';

export const container = styled.div`
    ${dFlex}
    ${alignCenter}
    gap: ${getSpacing('spaceLg')};
    width: 100%;
    padding: ${getSpacing('spaceLg')};
    background: ${getPrimitive('grays.gray100')};
    border-radius: ${getSpacing('spaceMd')};
`;

export const controlsWrapper = styled.div`
    ${dFlex}
    ${alignCenter}
    gap: ${getSpacing('spaceSm')};
`;

export const helpIconWrapper = styled.div`
    cursor: pointer;
    ${dFlex}
    
    &:hover {
        opacity: 0.8;
    }
`;

export const contentColumn = styled.div`
    ${dFlex}
    ${flexColumn}
    gap: ${getSpacing('spaceXs')};
    flex: 1;
`;

export const titleRow = styled.div`
    ${dFlex}
    ${alignCenter}
    gap: ${getSpacing('spaceMd')};
    width: 100%;
`;

export const title = styled.h3`
    font-weight: ${getFontWeight('bold')};
    font-size: ${getFontSize('caption')};
    text-align: start;
    color: ${getToken('color.text.default')};
`;

export const description = styled.p`
    font-weight: ${getFontWeight('regular')};
    font-size: ${getFontSize('caption')};
    text-align: start;
    color: ${getToken('color.text.default')};
    white-space: pre-wrap;
    width: 100%;
`;
